import {OrderStates, useDictionary} from '@adamlip/okeoke.client';
import useBasket from 'hooks/useBasket';
import {useContext, useEffect, useState} from 'react';
import {UserContext} from 'contexts/UserContext';
import SelectTableModal from 'components/SelectTableModal';
import {MainContext} from 'contexts/MainContext';
import {AppParamsContext} from 'contexts/AppParamsContext';
export default function SubmitButton() {
  const {appParams} = useContext(AppParamsContext);
  const {itemCount, orderState} = useBasket();
  const {getValue} = useDictionary();
  const {userLoggedIn} = useContext(UserContext);
  const {handleClickCart} = useContext(MainContext);

  const [buttonClass, setButtonClass] = useState('');
  const [buttonContainerClass, setButtonContainerClass] = useState('');
  const [selectTableOpen, setSelectTableOpen] = useState(false);

  useEffect(() => {
    let active = userLoggedIn && itemCount > 0 && orderState === OrderStates.BASKET;

    let containerBottom = '!bottom-0';
    let containerBg = '';

    //Button default
    if (appParams?.order?.submitButtonType == null || appParams?.order?.submitButtonType === '1') {
      containerBg = 'bg-[var(--order-items-bg-color)]';
    }

    //Button floating
    if (appParams?.order?.submitButtonType === '2') {
      containerBg = '';
    }

    //Bottombar not visible
    if (appParams?.styles?.topBottomBar?.bottomBarVisible === false) {
      containerBottom = '!bottom-[12px]';
      //Bottom visible
    } else {
      //Bottombar floating
      if (appParams?.navigation?.bottomBarSettings?.enabled == null || appParams?.navigation?.bottomBarSettings?.enabled === false) {
        if (appParams?.styles?.topBottomBar?.layout === 'floating') {
          containerBottom = '!bottom-[100px]';
        }
      } else {
        if (appParams?.navigation?.bottomBarSettings?.layout === 'floating') {
          containerBottom = '!bottom-[90px]';
          if (appParams?.navigation?.bottomBarSettings?.size === '70') {
            if (appParams?.navigation?.bottomBarSettings?.text === 'hidden') {
              containerBottom = '!bottom-[118px]';
            } else {
              containerBottom = '!bottom-[142px]';
            }
          }
          if (appParams?.navigation?.bottomBarSettings?.size === '55') {
            if (appParams?.navigation?.bottomBarSettings?.text === 'hidden') {
              containerBottom = '!bottom-[102px]';
            } else {
              containerBottom = '!bottom-[124px]';
            }
          }
          if (appParams?.navigation?.bottomBarSettings?.size === '40') {
            if (appParams?.navigation?.bottomBarSettings?.text === 'hidden') {
              containerBottom = '!bottom-[86px]';
            } else {
              containerBottom = '!bottom-[110px]';
            }
          }
        }
      }
    }

    /*
    bottom =
          appParams?.styles?.topBottomBar?.bottomBarVisible !== false
            ? "!bottom-[calc(var(--bottomBar-height)+35px)]"
            : "!bottom-[10px]";
    */

    const className = `${active ? 'primary' : 'disabled'} round float`;

    const containerClassName = `${containerBg} ${containerBottom}`;

    setButtonClass(className);
    setButtonContainerClass(containerClassName);
  }, [itemCount, orderState, appParams, userLoggedIn]);

  if (appParams?.order?.submitButtonType === '3') return null;

  return (
    <>
      <SelectTableModal isOpen={selectTableOpen} setIsOpen={setSelectTableOpen} />

      <div className={`w-full ${buttonContainerClass} h-[64px] absolute`}>
        <div className={`btn ${buttonClass}`} onClick={() => handleClickCart()}>
          {getValue('app_v2_submitOrderAndPay')}
        </div>
      </div>
    </>
  );
}
